<template>
  <span>
    <span v-for="(category, index) in categories" :key="index">
      <router-link
        :to="`/category/${category.slug}`"
        v-html="category.title" /><span v-if="index < categories.length - 1">, </span>
    </span>
  </span>
</template>
<script>
  export default {
    name: 'CategoriesList',
    props: [
      'categories'
    ]
  }
</script>


// WEBPACK FOOTER //
// src/components/CategoriesList.vue